import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import JamaVoucherPreviewModal from "../components/JamaVoucherPreviewModal";
import { voucherRowToSlipData } from "../components/JamaVoucherPDF";
import {
  getErpRequestErrorMessage,
  isErpApiSuccess,
  postCashbook,
} from "../erpClient";
import { getSessionBranchId } from "../utils/sessionBranch";

/**
 * View cash/bank in-out voucher via POST /cashbook type:show → slip preview.
 * Mixed book: bill_type Quotation → /quote, GST → /api (isQuote).
 */
export default function ViewCashbookVoucher({
  show,
  onHide,
  voucherId,
  isQuote,
  partyInfo = null,
}) {
  const [loading, setLoading] = useState(false);
  const [slipData, setSlipData] = useState(null);

  const partyName = partyInfo?.name || partyInfo?.label || "";
  const partyMobile = partyInfo?.mobile || "";
  const partyAddress = partyInfo?.address || "";
  const partyCity = partyInfo?.city || "";

  useEffect(() => {
    if (!show || voucherId == null || voucherId === "") {
      setSlipData(null);
      return undefined;
    }

    let cancelled = false;
    const load = async () => {
      const branchId = getSessionBranchId();
      if (branchId == null || branchId === "") {
        toast.error("Branch is required");
        onHide?.();
        return;
      }
      setLoading(true);
      setSlipData(null);
      try {
        const pinTypeOverride =
          isQuote === true ? "quote" : isQuote === false ? "access" : null;
        const response = await postCashbook(
          {
            type: "show",
            branch_id: Number(branchId) || branchId,
            id: voucherId,
          },
          pinTypeOverride != null ? { pinTypeOverride } : {},
        );
        if (cancelled) return;
        if (!isErpApiSuccess(response)) {
          toast.error(response?.message || "Unable to load voucher");
          onHide?.();
          return;
        }
        const voucher = response?.data;
        if (!voucher || typeof voucher !== "object" || Array.isArray(voucher)) {
          toast.error("Unable to load voucher");
          onHide?.();
          return;
        }
        setSlipData(
          voucherRowToSlipData(voucher, {
            party: partyName
              ? {
                  name: partyName,
                  mobile: partyMobile,
                  address: partyAddress,
                  city: partyCity,
                }
              : null,
          }),
        );
      } catch (err) {
        if (!cancelled) {
          toast.error(
            getErpRequestErrorMessage(err, "Unable to load voucher"),
          );
          onHide?.();
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [
    show,
    voucherId,
    isQuote,
    partyName,
    partyMobile,
    partyAddress,
    partyCity,
    onHide,
  ]);

  if (loading && show) {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ zIndex: 1060, background: "rgba(0,0,0,0.25)" }}
      >
        <div className="bg-white rounded shadow p-4 d-flex align-items-center gap-2">
          <Spinner animation="border" size="sm" />
          <span>Loading voucher…</span>
        </div>
      </div>
    );
  }

  return (
    <JamaVoucherPreviewModal
      show={show && !!slipData}
      onHide={onHide}
      voucherData={slipData}
    />
  );
}
